import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {WebService} from '../../services';
import type {IBaseResponse} from '../../services';
import type {IContainerTransitionMappingUpgrades, IContainerTransitionMappingDowngrades} from './interfaces';

@Module({name: 'containerTransitionMapping', namespaced: true})
export class ContainerTransitionMappingModule extends VuexModule {
	// Holds upgrade from non-container item -> container item
	containerTransitionMappingUpgrades: IContainerTransitionMappingUpgrades = {};
	// Holds downgrades from container item -> non-container item
	containerTransitionMappingDowngrades: IContainerTransitionMappingDowngrades = {};

	get upgradeMapping() {
		return (itemId: string | null) => {
			return itemId !== null && this.containerTransitionMappingUpgrades && this.containerTransitionMappingUpgrades[itemId] ? this.containerTransitionMappingUpgrades[itemId] : null;
		};
	}

	get downgradeMappings() {
		return (itemId: string | null) => {
			return itemId !== null && this.containerTransitionMappingDowngrades && this.containerTransitionMappingDowngrades[itemId] ? this.containerTransitionMappingDowngrades[itemId] : null;
		};
	}

	@Action
	async fetchContainerTransitionMappings() {
		const response = await WebService.authenticatedClient.get<IBaseResponse<{containerTransitionMappings: IContainerTransitionMappingUpgrades}>>('container_transition_mappings');
		this.setContainerTransitionMappings(response.data.data.containerTransitionMappings);
	}

	@Mutation
	public setContainerTransitionMappings(containerTransitionMappings: IContainerTransitionMappingUpgrades) {
		this.containerTransitionMappingUpgrades = containerTransitionMappings;
		this.containerTransitionMappingDowngrades = {};
		for(const oldItemHqId in containerTransitionMappings) {
			const mappingData = containerTransitionMappings[oldItemHqId];
			if(mappingData.itemHqId in this.containerTransitionMappingDowngrades) {
				const existing = this.containerTransitionMappingDowngrades[mappingData.itemHqId].find(
					(map) => {
						return map.optionId === mappingData.optionId && map.choiceId === mappingData.choiceId;
					}
				);
				if(existing) {
					console.warn('Already have mapping for this option/choice pair!', this.containerTransitionMappingDowngrades[mappingData.itemHqId]);
					continue;
				}
			} else {
				this.containerTransitionMappingDowngrades[mappingData.itemHqId] = [];
			}
			this.containerTransitionMappingDowngrades[mappingData.itemHqId].push({
				franchisorBase: mappingData.franchisorBase,
				oldItemHqId: mappingData.itemHqId,
				itemHqId: oldItemHqId,
				optionId: mappingData.optionId,
				choiceId: mappingData.choiceId
			});
		}
	}

	@Mutation
	public clearContainerTransitionMappings() {
		this.containerTransitionMappingUpgrades = {};
		this.containerTransitionMappingDowngrades = {};
	}
}
